import { render } from "./CamerasTabs.vue?vue&type=template&id=486e58a3"
import script from "./CamerasTabs.vue?vue&type=script&lang=js"
export * from "./CamerasTabs.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__